import React, { useContext } from 'react';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const TableNumberField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return <FullInfoField label="tableNumberLabel" value={deviceForFullInfo?.tableName} />;
};

export default TableNumberField;
